import { SvgIcon, SvgIconProps } from '@mui/material';

export function TrailingIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_3334_24003)">
          <path
            d="M6.53254 8.7825L8.47504 10.725C8.76754 11.0175 9.24004 11.0175 9.53254 10.725L11.475 8.7825C11.9475 8.31 11.61 7.5 10.9425 7.5H7.05754C6.39004 7.5 6.06004 8.31 6.53254 8.7825Z"
            fill="#2563EB"
          />
        </g>
        <defs>
          <clipPath id="clip0_3334_24003">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
